import React from 'react';
import { Skeleton } from '@chakra-ui/react';
import { ProductGrid } from './ProductGrid';
import SmallProgram from './SmallProgram';
import { ProgramInfo } from '../../../generated/graphqlModels';

interface ProgramListProps {
  programInfos: ProgramInfo[];
  isLoading: boolean;
}

const ProgramList = (props: ProgramListProps) => {
  const { programInfos, isLoading } = props;
  if (isLoading) {
    return (
      <ProductGrid id="program-list">
        {Array.from({ length: 6 }).map((_v, i) => (
          <Skeleton h="300px" />
        ))}
      </ProductGrid>
    );
  }
  return (
    <ProductGrid id="program-list">
      {programInfos.map((programInfo) => (
        <SmallProgram
          id={programInfo.id}
          name={programInfo.name}
          tags={programInfo.tags}
          description={programInfo.shortDescription || ''}
          image={programInfo.image?.url}
          organizationName={programInfo.organization?.name}
          organizationImage={programInfo.organization?.image?.url}
          slug={programInfo?.slug || ''}
        />
      ))}
    </ProductGrid>
  );
};

export default ProgramList;
